import React from "react";
import { useSelector } from "react-redux";
import { IMeal } from "../../../common/types";
import { Form, Select } from "../../atoms";
import { UserSelectedFieldWrapper } from "./Fields.style";

interface IMealSelectedFieldProps {
  bordered?: boolean;
  name: string | Array<string | number>;
  label?: string;
  rules?: any[];
  placeholder?: string;
  style?: any;
  mode?: "multiple" | "tags";
  maxTagCount?: number;
  initialValue?: any;
  getMeal?: () => IMeal;
  onChange?: (value: any) => void;
  disabled?: boolean;
}
export const MealSelectedField: React.FC<IMealSelectedFieldProps> = ({
  name,
  label,
  mode,
  rules,
  getMeal,
  onChange,
  bordered = true,
  style,
  placeholder,
  maxTagCount,
  initialValue,
  disabled,
}) => {
  const { meals } = useSelector((state: any) => state.meals);

  return (
    <UserSelectedFieldWrapper>
      <Form.Item
        label={label}
        name={name}
        rules={rules}
        initialValue={initialValue}
      >
        <Select
          showSearch
          bordered={bordered}
          style={style}
          placeholder={placeholder || label}
          optionFilterProp="label"
          filterOption={(input, option: any) =>
            option.search.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          options={meals.map((meal: IMeal) => ({
            value: meal.id,
            label: meal.name,
            search: `${meal?.name || ""}`,
          }))}
          mode={mode}
          maxTagCount={maxTagCount}
          onChange={onChange}
          disabled={disabled}
        ></Select>
      </Form.Item>
    </UserSelectedFieldWrapper>
  );
};

export default MealSelectedField;
